module.exports = __webpack_public_path__ + "img/left-arrow-unselected.ee749ce5.svg";